/* Ribelli Merkliste (Wishlist) – localStorage-basiert, ohne App.

   Texte kommen aus window.schaeferStrings (siehe layout/theme.liquid).
   Dieses Skript baut sein Markup zur Laufzeit; fest eingetragene Texte
   wären dadurch von der Übersetzung abgeschnitten.

   Speicherschlüssel: beim Umbenennen von "dealfux" auf "ribelli" (29.08.2026)
   wurde auch der Schlüssel umgezogen. Damit niemand seine Liste verliert,
   wird der ALTE Schlüssel einmalig übernommen und danach entfernt. */
(function () {
  var T = window.schaeferStrings || {};
  var KEY = 'ribelli_wishlist';
  var ALT_KEY = 'df_wishlist';

  try {
    if (!localStorage.getItem(KEY) && localStorage.getItem(ALT_KEY)) {
      localStorage.setItem(KEY, localStorage.getItem(ALT_KEY));
      localStorage.removeItem(ALT_KEY);
    }
  } catch (e) {
    /* Privater Modus o. ae. — dann startet die Liste eben leer. */
  }

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    updateCount();
    markHearts();
  }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  function updateCount() {
    var n = read().length;
    document.querySelectorAll('.rb-fav-count').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('hidden', n === 0);
    });
  }

  function markHearts() {
    var list = read();
    document.querySelectorAll('[data-rb-handle]').forEach(function (btn) {
      btn.classList.toggle('is-active', list.indexOf(btn.getAttribute('data-rb-handle')) !== -1);
    });
  }

  /* ---------- Modal ---------- */
  function openModal() {
    var modal = document.getElementById('DfWishlistModal');
    if (!modal) return;
    modal.classList.add('is-open');
    document.body.classList.add('rb-no-scroll');
    renderList();
  }
  function closeModal() {
    var modal = document.getElementById('DfWishlistModal');
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('rb-no-scroll');
  }

  function renderList() {
    var wrap = document.getElementById('DfWishlistItems');
    if (!wrap) return;
    var list = read();
    if (!list.length) {
      wrap.innerHTML = '<p class="rb-wl__empty">' + T.wishlistEmpty + '<br>' + T.wishlistEmptyHint + '</p>';
      return;
    }
    wrap.innerHTML = '<p class="rb-wl__loading">' + T.wishlistLoading + '</p>';
    Promise.all(
      list.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      // DOM-Aufbau statt HTML-String: Titel/Handle/URL stammen aus der
      // Produkt-API und landeten vorher unkaskiert in innerHTML — ein '<'
      // oder Anfuehrungszeichen im Produkttitel (10" Pfanne) brach das
      // Markup, ein boeswilliger Titel waere ausgefuehrt worden.
      wrap.textContent = '';
      var alive = products.filter(Boolean);
      if (!alive.length) {
        var empty = document.createElement('p');
        empty.className = 'rb-wl__empty';
        empty.textContent = T.wishlistEmpty;
        wrap.appendChild(empty);
      }
      alive.forEach(function (p) {
        var img = p.featured_image ? p.featured_image + '&width=200' : '';
        if (img && img.indexOf('?') === -1) img = img.replace('&width', '?width');
        var price = (p.price / 100).toFixed(2).replace('.', ',') + ' €';

        var row = document.createElement('div');
        row.className = 'rb-wl__row';

        if (img) {
          var imgLink = document.createElement('a');
          imgLink.href = p.url;
          var im = document.createElement('img');
          im.src = img; im.alt = ''; im.loading = 'lazy';
          imgLink.appendChild(im);
          row.appendChild(imgLink);
        }

        var info = document.createElement('div');
        info.className = 'rb-wl__info';
        var title = document.createElement('a');
        title.className = 'rb-wl__title';
        title.href = p.url;
        title.textContent = p.title;
        var priceEl = document.createElement('span');
        priceEl.className = 'rb-wl__price';
        priceEl.textContent = price;
        info.appendChild(title);
        info.appendChild(priceEl);
        row.appendChild(info);

        var actions = document.createElement('div');
        actions.className = 'rb-wl__actions';
        var view = document.createElement('a');
        view.className = 'rb-wl__view';
        view.href = p.url;
        view.textContent = T.wishlistView;
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'rb-wl__remove';
        remove.setAttribute('data-rb-remove', p.handle);
        remove.setAttribute('aria-label', T.wishlistRemove);
        remove.innerHTML = '&times;';
        actions.appendChild(view);
        actions.appendChild(remove);
        row.appendChild(actions);

        wrap.appendChild(row);
      });
    });
  }

  /* ---------- Events (Delegation) ---------- */
  document.addEventListener('click', function (e) {
    var fav = e.target.closest('[data-rb-handle]');
    if (fav) {
      e.preventDefault();
      e.stopPropagation();
      var added = toggle(fav.getAttribute('data-rb-handle'));
      fav.classList.add('rb-pop');
      setTimeout(function () { fav.classList.remove('rb-pop'); }, 350);
      if (added) {
        fav.setAttribute('aria-label', T.wishlistDrop);
      } else {
        fav.setAttribute('aria-label', T.wishlistAdd);
      }
      return;
    }
    if (e.target.closest('[data-rb-open-wishlist]')) {
      e.preventDefault();
      openModal();
      return;
    }
    if (e.target.closest('[data-rb-close-wishlist]') || e.target.classList.contains('rb-wl__overlay')) {
      closeModal();
      return;
    }
    var rm = e.target.closest('[data-rb-remove]');
    if (rm) {
      toggle(rm.getAttribute('data-rb-remove'));
      renderList();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateCount();
    markHearts();
  });
  document.addEventListener('shopify:section:load', markHearts);
  updateCount();
  markHearts();
})();
